import dayjs, { Dayjs } from "dayjs";

export const DATE_FORM_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORM_FORMAT = "YYYY-MM-DDTHH:mm:ss";

// strings are parsed through Date, as the wrapper always did, so non-ISO inputs keep behaving the same
export const toDayjsOrNull = (value: unknown): Dayjs | null => {
  if (value === undefined || value === null || value === "") return null;
  if (dayjs.isDayjs(value)) return value;
  if (value instanceof Date) return dayjs(value);
  return dayjs(new Date(value as string));
};

export const applyPickedDateTime = (
  current: Dayjs | null,
  picked: Dayjs
): Dayjs =>
  dayjs(current || dayjs())
    .set("year", picked.year())
    .set("month", picked.month())
    .set("date", picked.date())
    .set("hour", picked.hour())
    .set("minute", picked.minute());

export const applyPickedDate = (current: Dayjs | null, picked: Dayjs): Dayjs =>
  dayjs(current || dayjs())
    .set("year", picked.year())
    .set("month", picked.month())
    .set("date", picked.date());
